/**
 * Permissions API Routes
 *
 * All routes related to the granular permissions system
 * NOTE: Org roles routes are prefixed with /api/admin/org/roles
 */

export const PERMISSIONS_ROUTES = {
  // Get all permissions (for admin UI)
  GET_ALL_PERMISSIONS: '/api/admin/org/roles/permissions',

  // Get user permissions summary
  GET_USER_PERMISSIONS: (userId: string) => `/api/users/${userId}/permissions`,

  // Get user permission overrides
  GET_USER_PERMISSION_OVERRIDES: (userId: string) => `/api/users/${userId}/permissions/overrides`,

  // Update user permission override
  UPDATE_USER_PERMISSION: (userId: string, permissionId: string) =>
    `/api/users/${userId}/permissions/${permissionId}`,

  // Remove user permission override
  REMOVE_USER_PERMISSION: (userId: string, permissionId: string) =>
    `/api/users/${userId}/permissions/${permissionId}`,

  // Get custom roles for tenant
  GET_CUSTOM_ROLES: '/api/admin/org/roles',

  // Get custom role by ID
  GET_CUSTOM_ROLE: (roleId: string) => `/api/admin/org/roles/${roleId}`,

  // Create custom role
  CREATE_CUSTOM_ROLE: '/api/admin/org/roles',

  // Update custom role
  UPDATE_CUSTOM_ROLE: (roleId: string) => `/api/admin/org/roles/${roleId}`,

  // Delete custom role
  DELETE_CUSTOM_ROLE: (roleId: string) => `/api/admin/org/roles/${roleId}`,

  // Get custom role permissions
  GET_CUSTOM_ROLE_PERMISSIONS: (roleId: string) => `/api/admin/org/roles/${roleId}/permissions`,

  // Set custom role permissions (replace all permissions)
  SET_CUSTOM_ROLE_PERMISSIONS: (roleId: string) => `/api/admin/org/roles/${roleId}/permissions`,

  // Add permissions to a role (keeps existing)
  ADD_CUSTOM_ROLE_PERMISSIONS: (roleId: string) => `/api/admin/org/roles/${roleId}/permissions`,

  // Remove permission from a role
  REMOVE_CUSTOM_ROLE_PERMISSION: (roleId: string, permissionKey: string) =>
    `/api/admin/org/roles/${roleId}/permissions/${permissionKey}`,

  // Get users assigned to a role
  GET_ROLE_USERS: (roleId: string) => `/api/admin/org/roles/${roleId}/users`,

  // Assign role to a user
  ASSIGN_ROLE_TO_USER: (roleId: string) => `/api/admin/org/roles/${roleId}/users`,

  // Remove role from a user
  REMOVE_ROLE_FROM_USER: (roleId: string, userId: string) =>
    `/api/admin/org/roles/${roleId}/users/${userId}`,

  // Assign custom role to user (legacy - maps to role assignment)
  ASSIGN_CUSTOM_ROLE: (userId: string) => `/api/users/${userId}/custom-roles`,

  // Remove custom role from user (legacy)
  REMOVE_USER_CUSTOM_ROLE: (userId: string, roleId: string) =>
    `/api/users/${userId}/custom-roles/${roleId}`,

  // Get user custom roles
  GET_USER_CUSTOM_ROLES: (userId: string) => `/api/users/${userId}/custom-roles`,

  // Get current user permissions (for frontend use)
  GET_MY_PERMISSIONS: '/api/me/permissions',
} as const
